export default __webpack_public_path__ + "static/media/photo--lg--34.ebe3b7d5.jpg";